import { action, observable, computed, makeObservable } from "mobx";
import { VehicleModelData } from "./ServicePlanModels";

export default class ServicePlanModel {
  @observable response: VehicleModelData[] = [];
  @observable isContentExist: boolean = false;
  @observable isRequestError: boolean = false;
  @observable isLoading: boolean = true;

  constructor() {
    makeObservable(this);
  }

  @computed get length() {
    return this.response ? this.response.length : 0;
  }

  @action reset = () => {
    this.response = null;
    this.isContentExist = false;
    this.isRequestError = false;
  };
}
